<div class="pos-panel">
  <ng-container *ngIf="venueId">
  <div class="pos-panel-header">
      <span class="soc-panel-header">{{'NAVBAR.DASHBOARD' | translate}}</span>
      <hr class="soc-panel-line"/>
  </div>
  <div class="d-flex justify-content-between">
      <span class="soc-h4">{{venue.name}}</span>
      <div class="soc-datepicker-wrapper">
        <span class="material-icons calendar-icon">calendar_month</span>
        <p-calendar [(ngModel)]="date" (onSelect)="onDateChange()" dateFormat="dd M yy" [readonlyInput]="true"></p-calendar>
      </div>
  </div> 
  <hr class="soc-panel-line"/> 
  <div class="soc-wrapper-gap-24">
    <div id="pos-dashboard-total-income" class="pos-dashboard-card">
      <span class="soc-panel-h">{{'DASHBOARD.TOTAL_INCOME' | translate}}</span>
      <div class="soc-h4">{{totalIncome?.income}}</div>
      <div class="soc-wrapper-gap-12">
        <img src="assets/icons/trend.png" height="24" width="24"/>
        <span class="soc-p">{{totalIncome?.profitMarginInPercentage}} % {{'DASHBOARD.UP_FROM_YESTERDAY' | translate}}</span>
      </div>
    </div>
    <div id="pos-dashboard-all-orders" class="pos-dashboard-card">
      <span class="soc-panel-h">{{'DASHBOARD.ALL_ORDERS' | translate}}</span>
      <div class="soc-h4">{{allOrders?.allOrders}}</div>
      <div class="d-flex justify-content-between">
        <div class="soc-wrapper-gap-12">
          <img src="assets/icons/bill_icon_cyan.svg" height="24" width="24" />
          <span class="soc-p"><b>{{allOrders?.openOrders}}</b> {{'DASHBOARD.OPEN_ORDERS' | translate}} </span>
        </div>
        <div class="soc-wrapper-gap-12">
          <img src="assets/icons/order_icon_cyan.svg" height="24" width="24"/>
          <span class="soc-p"><b>{{allOrders?.unpaidBills}}</b> {{'DASHBOARD.UNPAID_BILLS' | translate}}</span>
        </div>
      </div>

    </div>
   
  </div>
  </ng-container>
</div>
